import React from 'react';

const CharterMockupSection = () => {
  return (
    <section className="section-padding-sm bg-[var(--bg-secondary)]">
      <div className="container">
        <div className="max-w-4xl mx-auto text-center">
          {/* Headline */}
          <h2 className="heading-2 mb-12">
            This is what structured protection clarity looks like
          </h2>
          
          {/* Mockup Image */}
          <div className="mb-8">
            <img 
              src="https://customer-assets.emergentagent.com/job_b2ceecb0-da08-477c-bdbc-45b3f8bca466/artifacts/afsq8yl9_Product%20Mock%20UP%20-%20Charter.jpg"
              alt="Family Protection Charter System"
              className="w-full h-auto rounded-lg shadow-lg"
              loading="lazy"
            />
          </div>
          
          {/* Subline */}
          <p className="body-large text-[var(--text-secondary)] max-w-2xl mx-auto">
            Not a document. A complete system your family can rely on — even when you're not around.
          </p>
        </div>
      </div>
    </section>
  );
};

export default CharterMockupSection;
